module.exports = __webpack_public_path__ + "static/media/lc_nov.1cd7bf64.png";